import { Checkbox } from '@mui/material';
import React from 'react'

function RowCheckbox(props) {
    const { customClasses = '', rowDataId, selected, disabledCheckbox,isCheckboxHidden=undefined, actions: { setSelected } } = props;

    function onCheckboxClick(rowId, isChecked) {

        if (isChecked) {
            const sRows = [
                ...selected,
                rowId,
            ]
            setSelected(sRows);
        } else {
            const sRows = selected.filter(x => x !== rowId);
            setSelected(sRows);
        }
    }

    return (
        <Checkbox
            disabled={disabledCheckbox ? true : false}
            className={customClasses}
            color="primary"
            checked={(selected.find(item => item === rowDataId) && !isCheckboxHidden) ? true : false}
            onChange={(event) => onCheckboxClick(rowDataId, event.target.checked)}
            tabIndex={-1}
            disableRipple
        />
    )
}

export default RowCheckbox
